import { useState } from "react";
import { useNavigate, useSearchParams, Link } from "react-router-dom";
import api from "@/lib/api";
import { formatApiErrorDetail } from "@/context/AuthContext";
import { useI18n } from "@/context/I18nContext";
import { LoginLangPicker } from "@/pages/Login";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { toast } from "sonner";
import { Loader2 } from "lucide-react";

export default function ResetPassword() {
  const { t } = useI18n();
  const [params] = useSearchParams();
  const nav = useNavigate();
  const token = params.get("token") || "";
  const [pass, setPass] = useState("");
  const [pass2, setPass2] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    if (pass.length < 8) { toast.error(t("Le mot de passe doit contenir au moins 8 caractères")); return; }
    if (pass !== pass2) { toast.error(t("Les deux mots de passe ne sont pas identiques")); return; }
    setLoading(true);
    try {
      await api.post("/auth/reset-password", { token, password: pass });
      toast.success(t("Mot de passe enregistré. Vous pouvez vous connecter."));
      nav("/login");
    } catch (err) {
      toast.error(t(formatApiErrorDetail(err.response?.data?.detail) || err.message));
    } finally { setLoading(false); }
  };

  return (
    <div className="min-h-screen bg-background flex items-center justify-center p-6" data-testid="reset-page">
      <div className="w-full max-w-md">
        <div className="flex items-center justify-between mb-6">
          <img src="/assets/fautras-logo.png" alt="Fautras" className="h-12 w-auto" />
          <LoginLangPicker />
        </div>
        <h1 className="font-display text-2xl font-bold">{t("Choisir mon mot de passe")}</h1>
        {!token ? (
          <p className="text-sm text-destructive mt-4" data-testid="reset-missing-token">{t("Lien incomplet. Refaites une demande depuis la page de connexion.")}</p>
        ) : (
          <form onSubmit={submit} className="space-y-4 mt-6">
            <div><Label htmlFor="r-pass">{t("Nouveau mot de passe (8 caractères minimum)")}</Label>
              <Input id="r-pass" type="password" autoComplete="new-password" required value={pass} onChange={(e) => setPass(e.target.value)} className="mt-1.5" data-testid="reset-password" /></div>
            <div><Label htmlFor="r-pass2">{t("Confirmer le mot de passe")}</Label>
              <Input id="r-pass2" type="password" autoComplete="new-password" required value={pass2} onChange={(e) => setPass2(e.target.value)} className="mt-1.5" data-testid="reset-password-confirm" /></div>
            <Button type="submit" className="w-full" disabled={loading} data-testid="reset-submit">
              {loading ? <Loader2 className="w-4 h-4 animate-spin" /> : t("Enregistrer mon mot de passe")}
            </Button>
          </form>
        )}
        <Link to="/login" className="block text-sm text-muted-foreground underline mt-4" data-testid="reset-back-login">{t("Retour à la connexion")}</Link>
      </div>
    </div>
  );
}
